'use strict';

/**
 * Encapsulates the logic for issuing a request to the Stripe API. This is an
 * experimental interface and is not yet stable.
 */
var _classCallCheck = require("/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var HttpClient = /*#__PURE__*/function () {
  function HttpClient() {
    _classCallCheck(this, HttpClient);
  }
  _createClass(HttpClient, [{
    key: "getClientName",
    /** The client name used for diagnostics. */value: function getClientName() {
      throw new Error('getClientName not implemented.');
    }
  }, {
    key: "makeRequest",
    value: function makeRequest(host, port, path, method, headers, requestData, protocol, timeout) {
      throw new Error('makeRequest not implemented.');
    } /** Helper to make a consistent timeout error across implementations. */
  }], [{
    key: "makeTimeoutError",
    value: function makeTimeoutError() {
      var timeoutErr = new TypeError(HttpClient.TIMEOUT_ERROR_CODE);
      timeoutErr.code = HttpClient.TIMEOUT_ERROR_CODE;
      return timeoutErr;
    }
  }]);
  return HttpClient;
}();
HttpClient.TIMEOUT_ERROR_CODE = 'ETIMEDOUT';
var HttpClientResponse = /*#__PURE__*/function () {
  function HttpClientResponse(statusCode, headers) {
    _classCallCheck(this, HttpClientResponse);
    this._statusCode = statusCode;
    this._headers = headers;
  }
  _createClass(HttpClientResponse, [{
    key: "getStatusCode",
    value: function getStatusCode() {
      return this._statusCode;
    }
  }, {
    key: "getHeaders",
    value: function getHeaders() {
      return this._headers;
    }
  }, {
    key: "getRawResponse",
    value: function getRawResponse() {
      throw new Error('getRawResponse not implemented.');
    }
  }, {
    key: "toStream",
    value: function toStream(streamCompleteCallback) {
      throw new Error('toStream not implemented.');
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      throw new Error('toJSON not implemented.');
    }
  }]);
  return HttpClientResponse;
}();
module.exports = {
  HttpClient: HttpClient,
  HttpClientResponse: HttpClientResponse
};